import queryString from "query-string";
import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { ConstructionItemSetting } from "~/models/ConstructionItemSetting";

const paths = {
	index: "/construction_item_settings"
};
type TIndex = (
	vendorCompanyId: number | null
) => SwrReturnType<ConstructionItemSetting[]>;
type ReturnType = {
	index: TIndex;
};

export const useConstructionItemSettings = (): ReturnType => {
	const index: TIndex = (vendorCompanyId: number | null) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<ConstructionItemSetting[]>(
			queryString.stringifyUrl({
				query: { vendor_company_id: vendorCompanyId },
				url: paths.index
			})
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index };
};
